import React,{useState,useEffect} from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import OrderDetails from '../../components/OrderDetails'
import { useParams , useSearchParams,useNavigate } from "react-router-dom";

const ShoppingOrderConfirmationPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [refnum, setRefnum] = useState(false);
    const [status, setStatus] = useState(false);
    useEffect(async () => {
        if(searchParams.get("refnum"))setRefnum({refnum:searchParams.get("refnum"),draftOrder:searchParams.get("draftOrder")});
        if(searchParams.get("status"))setStatus(searchParams.get("status"));
      }, [searchParams])

    return (
        <>
            <Helmet>
                <title>Order Info</title>
            </Helmet>
            <Header />
            <ActiveCatalogue />
            {refnum && <OrderDetails pendingOrder={refnum} status={status}/>}
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default ShoppingOrderConfirmationPage